module.exports = __webpack_public_path__ + "img/sprinkle-26.0c5aa4d8.webp";